import styled from "styled-components";
import {File, StyledBaseProps} from "@betrue/shared/interfaces";
import {FileLinkProps} from "@betrue/ui";
import React from "react";
import {IconButton, Link} from "@material-ui/core";
import {fileUrl} from "@betrue/front/services";
import HighlightOffOutlinedIcon from "@material-ui/icons/HighlightOffOutlined";

export interface FileLinkViewProps extends StyledBaseProps, FileLinkProps {
  file: File
  onDelete: (file: File) => void
  removable: boolean
}

export const FileLinkView = styled((props: FileLinkViewProps) => (
  <div className={props.className}>
    <Link target={'_blank'}
          href={fileUrl(props.file)}>{props.file.filename}</Link>
    {props.removable ? (<IconButton title={props.deleteLabel ? props.deleteLabel : 'Supprimer'}
                                    onClick={(e) => props.onDelete(props.file)}>
      <HighlightOffOutlinedIcon/>
    </IconButton>) : ('')}
  </div>
))``
